import React from "react";
import stackdata from "../data/stackdata";

const OurExpertise = () => {
  return (
    <section className="expertise py-5">
      <div className="container">
        <div data-aos="fade-up">
          <h4 className="font-heading text-center text-white m-0 lh-small">
            Find different stacks in our network of developers
          </h4>
          <p className="text-center font-normal mb-2 text-white">
            wedevelopers covers every tech stacks
          </p>
        </div>
        <div
          className="d-flex wrap justify-content-center exp-wrapper"
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="1000">
          {stackdata.slice(0, 16).map((data, i) => (
            <a
              className="font-normal text-white text-uppercase"
              key={i}
              href={`/hire/${data.slug}`}>
              <i className={`${data.icon} mr-1`}></i>
              {data.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurExpertise;
